<div class="tab-box">
  <div class="displayFlexJustify">
    <div class="zgbox">
      <!-- si no hay datos aparecerá deshabilitado, incluir clase  zgbox__disabled -->
      <div>
        <h2>
          Zonas
          <img src="../../../../assets/lapiz.svg" alt="" (click)="openDialogCambiarzg()" role="button" *ngIf="role != 'user'"/>
        </h2>
        <ul>
          <li *ngFor="let zona of zonas">
            <span class="point"></span>
            {{zona.nombre}}
          </li>
        </ul>
      </div>
      <button class="boton-añadir-zona" (click)="openDialog()" *ngIf="role != 'user'">
        Añadir o Eliminar Zona
      </button>
    </div>

    <div class="zgbox" *ngFor="let grupo of grupos">
      <div>
        <h2>
         {{grupo.nombre}}
         <img src="../../../../assets/lapiz.svg" alt="" (click)="openDialogCambiarGrupo(grupo)" role="button" *ngIf="role != 'user'"/>
        </h2>
        <ul>
          <li *ngFor="let camp of grupo.campos" >
            <span class="point"></span>
            {{camp.nombre}}
          </li>
          
        </ul>
      </div>
    
      <button class="boton-añadir-zona" (click)="openDialogGrupo(grupo)"  *ngIf="grupo && role != 'user'">
        
        Editar o Eliminar Grupo
      </button>

    </div>
    <div class="zgbox zgbox__disabled" *ngIf="grupos?.length < 1">
      <div>
        <h2>
          Nuevo Grupo1
          <span><img src="../../../../assets/lapiz.svg" alt="" *ngIf="role != 'user'"/></span>
        </h2>
      </div>

      <button class="boton-añadir" (click)="addGrupo()" *ngIf="role != 'user'">
        Nuevo grupo
      </button>
    </div>

     <div class="zgbox zgbox__disabled" *ngIf="grupos?.length < 2">
      <div>
        <h2>
          Nuevo Grupo2
          <span><img src="../../../../assets/lapiz.svg" alt="" *ngIf="role != 'user'"/></span>
        </h2>
      </div>

      <button class="boton-añadir" (click)="addGrupo()" *ngIf="role != 'user'">
        Nuevo grupo
      </button>
    </div> 

    <div class="zgbox zgbox__disabled" *ngIf="grupos?.length < 3">
      <div>
        <h2>
          Nuevo Grupo3
          <span><img src="../../../../assets/lapiz.svg" alt="" *ngIf="role != 'user'"/></span>
        </h2>
      </div>

      <button class="boton-añadir" (click)="addGrupo()"  *ngIf="role != 'user'">
        Nuevo grupo
      </button>
    </div>
    <div class="zgbox zgbox__disabled" *ngIf="grupos?.length < 4">
      <div>
        <h2>
          Nuevo Grupo4
          <span><img src="../../../../assets/lapiz.svg" alt="" *ngIf="role != 'user'"/></span>
        </h2>
      </div>

      <button class="boton-añadir" (click)="addGrupo()" *ngIf="role != 'user'">
        Nuevo grupo
      </button>
    </div>
  </div> 

  <h3 class="title-instalaciones">Instalaciones asignadas</h3>
  <div>
    Seleccione una Zona o Grupo para ver las Instalaciones Asignadas
  </div> 
<div class="displayFlex">
  <mat-form-field appearance="outline" class="dropdown">
    <mat-label>Zona</mat-label>
    <mat-select
      name="zona"
      placeholder="Filtrar por zona"
      class="selector__motivo"
      [(value)]="zonaSeleccionado" (selectionChange)="selectZona($event.value)"
    >
    <mat-option *ngFor="let zona of zonas" [value]="zona.id" >
      {{zona.nombre}}
    </mat-option>
  </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="dropdown">
    <mat-label>Grupo</mat-label>
    <mat-select
      name="grupo"
      placeholder="Filtrar por grupo"
      class="selector__motivo"
      [(value)]="grupoSeleccionado" (selectionChange)="selectGrupo($event.value)"
    >
    <mat-option *ngFor="let grupo of grupos" [value]="grupo.id" >
      {{grupo.nombre}}
    </mat-option>
  </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" class="dropdown">
    <mat-label>Campo</mat-label>
    <mat-select
      name="campo"
      placeholder="Filtrar por campo"
      class="selector__motivo"
      [(value)]="campoSeleccionado" (selectionChange)="selectCampo($event.value)"
    >
    <mat-option *ngFor="let campo of campos" [value]="campo.id" >
      {{campo?.nombre}}
    </mat-option>
  </mat-select>
  </mat-form-field>
</div>
  <div *ngIf="zonaSeleccionado && instalaciones?.length > 0">
    <div class="check-info">
      <strong>Las Instalaciones de la Zona seleccionada son:</strong>
  </div>
  <div class="check-zg">
    <div class="check" *ngFor="let instalacion of instalaciones">
      <span class="point"></span>
      -{{instalacion.nombre}}
    </div>
  </div>
</div>
  <div *ngIf="campoSeleccionado && campoInstalaciones?.length > 0">
    <div class="check-info">
    <strong>Las Instalaciones del Campo seleccionado son:</strong>
  </div>
  <div class="check-zg">

    <div class="check" *ngFor="let campoInstalacion of campoInstalaciones">
      <span class="point"></span>
      -{{campoInstalacion?.nombre}}
    </div>
  </div>
</div>
</div>
